import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-sidebar-nav-section-link',
  template: '<ng-content></ng-content>',
  styles: [':host { display: none; }']
})
export class SidebarNavSectionLinkComponent implements OnInit {
  @Input() label = '';
  @Input() routerLink = '';
  @Input() href = '';
  @Input() title = '';
  @Input() iconClass = '';
  @Input() exact = false;
  @Input() slimOnly = false;

  hidden = false;
  isActive = false;

  get isExternalLink(): boolean {
    return !!this.href;
  }

  get displayIconClass(): string {
    // Default to external link icon if external and no icon specified
    if (this.isExternalLink && !this.iconClass) {
      return 'fas fa-external-link-alt';
    }
    return this.iconClass;
  }

  constructor(
    private router: Router,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // Only track active state for internal links
    if (!this.isExternalLink) {
      // Listen to route changes to ensure proper active state
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {
          this.updateActiveState();
          this.cd.detectChanges();
        });
      
      // Initial active state check
      this.updateActiveState();
    }
  }

  private updateActiveState(): void {
    if (this.isExternalLink) {
      this.isActive = false;
      return;
    }
    
    const currentUrl = this.router.url;
    if (this.exact) {
      this.isActive = currentUrl === this.routerLink;
    } else {
      this.isActive = currentUrl.startsWith(this.routerLink);
    }
  }

  navigate(): void {
    if (this.isExternalLink) {
      window.open(this.href, '_blank');
    } else {
      this.router.navigate([this.routerLink]);
    }
  }
}
